import Cookies from 'js-cookie'
import api from '../api'

export const state = {
	language: '',

	translatedText: [
		{ dashboard: [] },
		{ navbar: [] },
		{ manage_session: [] },
		{ create_session: [] },
		{ session_view: [] },
		{ user_view: [] },
		{ report: [] },
		{ cassia_router: [] }
	],

	translatedBeforeAuthText: [
		{ session_view: [] },
		{ login: [] },
		{ forgot_password: [] },
		{ sign_up: [] },
		{ report: [] }
	],

	hasTranslationText: false,
	loading: false
}

export const mutations = {
	SET_LANGUAGE (state, payload) {
		// this._vm.$translate.setLang(payload)
		state.language = payload
	},

	LANGUAGE_TRANSLATION_SUCCESS (state, payload) {
		const isUserAuthenticated = this.getters.getLoggedInState && Cookies.get('token')

		// If User Logged In, Use translatedText otherwise use translatedBeforeAuthText
		const translateObj = isUserAuthenticated ? 'translatedText' : 'translatedBeforeAuthText'

		state[translateObj] = payload

		let pages = isUserAuthenticated
			? ['dashboard', 'navbar', 'manage_session', 'create_session', 'session_view', 'user_view', 'report', 'cassia_router']
			: ['session_view', 'login', 'forgot_password', 'sign_up', 'report']

		pages.forEach((page, index) => {
			const object = state[translateObj][index][page].reduce((acc, x) => {
				Object.keys(x).forEach((item, index) => {
					if (Object.keys(acc).includes(item)) {
						acc[`${item}_${index + 1}`] = x[item]

						return
					}

					acc[item] = x[item]
				})

				return acc
			}, {})

			state[translateObj][index][page] = object
		})

		state.hasTranslationText = true
		state.loading = false
	},

	LANGUAGE_TRANSLATION_FAIL (state, payload) {
		state.translatedText = [
			{ dashboard: [] },
			{ navbar: [] },
			{ manage_session: [] },
			{ create_session: [] },
			{ session_view: [] },
			{ user_view: [] },
			{ report: [] }
		]

		state.translatedBeforeAuthText = [
			{ login: [] },
			{ forgot_password: [] },
			{ sign_up: [] },
			{ report: [] }
		]

		state.hasTranslationText = false
		state.loading = false
	}
}

export const actions = {
	setLanguage ({ commit }, payload) {
		if (payload) {
			const code = payload === 'english' ? 'en' : 'jpn'

			if (Cookies.get('lang') && Cookies.get('lang') === code) {
				commit('SET_LANGUAGE', code === 'en' ? 'english' : 'japanese')
				return
			}

			Cookies.set('lang', code)
			commit('SET_LANGUAGE', payload)
			return
		} else if (Cookies.get('lang')) {
			commit('SET_LANGUAGE', Cookies.get('lang') === 'en' ? 'english' : 'japanese')
			return
		}

		Cookies.set('lang', 'en')
		commit('SET_LANGUAGE', 'english')
	},

	async getTranslation ({ commit, state }, payload) {
		state.loading = true

		const { data, status } = await api('get', '/insight/translation/list?cms_type=workspace&language=' + state.language)

		if (!(status && data.status === 200)) {
			commit('LANGUAGE_TRANSLATION_FAIL', data)

			return
		}

		await commit('LANGUAGE_TRANSLATION_SUCCESS', data.data)
	},

	async getBeforeAuthTranslation ({ commit, state }, payload) {
		state.loading = true

		const { data, status } = await api('get', '/insight/translation/before-signin-translations?cms_type=workspace&language=' + state.language)

		if (!(status && data.status === 200)) {
			commit('LANGUAGE_TRANSLATION_FAIL', data)

			return
		}

		await commit('LANGUAGE_TRANSLATION_SUCCESS', data.data)
	}
}

export const getters = {
	// Before Auth Translations
	getUserDisplayTranslation: state => state.translatedBeforeAuthText[0].session_view,
	getLoginTranslation: state => state.translatedBeforeAuthText[1].login,
	getForgotPasswordTranslation: state => state.translatedBeforeAuthText[2].forgot_password,
	getSignUpTranslation: state => state.translatedBeforeAuthText[3].sign_up,
	getReportTranslation: state => state.translatedBeforeAuthText[4].report,

	// Authenticated Translations
	getDashboardTranslation: state => state.translatedText[0].dashboard,
	getNavbarTranslation: state => state.translatedText[1].navbar,
	getManageSessionTranslation: state => state.translatedText[2].manage_session,
	getCreateSessionTranslation: state => state.translatedText[3].create_session,
	getSessionViewTranslation: state => state.translatedText[4].session_view,
	getUserViewTranslation: state => state.translatedText[5].user_view,
	getAuthReportTranslation: state => state.translatedText[6].report,
	getMassTranslation: state => state.translatedText[7].cassia_router
}

export default {
	state,
	namespaced: false,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/global/translation.js